import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../components/home/home'
import Index from '../components/index/index'
import Information from '../components/home.information/information'
import Detail from '../components/home.information.detail/detail'
import DetailPhone from '../components/home.information.detail/detailPhone.vue'
import InforList from '../components/home.information.list/list'
import InforFastList from '../components/home.information.list/fastList'
import Report from '../components/home.report/report'
import ReportDetail from '../components/home.report.detail/detail'
import PriceIndex from '../components/home.priceIndex/priceIndex'
import BasePrice from '../components/home.basePrice/basePrice'
import AllPrice from '../components/home.allPrice/allPrice'
import ModifyPrice from '../components/home.modifyPrice/modifyPrice'
import Customized from '../components/home.modifyPrice.customized/customized'
import CurrentCash from '../components/home.currentCash/currentCash'
import BilletAdjustment from '../components/home.billetAdjustment/billetAdjustment'
import Record from '../components/home.record/record'
import SelfPage from '../components/home.selfPage/selfPage'
import ChangePwd from '../components/home.changePwd/changePwd'
import SiteMap from '../components/home.siteMap/siteMap'
import FeedBack from '../components/home.feedBack/feedBack'
import SearchPage from '../components/home.searchPage/searchPage'
import ServiceDetail from '../components/home.serviceDetail/serviceDetail'
import ServiceSystem from '../components/z.serviceSystem/serviceSystem'
import AboutUs from '../components/z.aboutUs/aboutUs'
import Quote from '../components/home.quote/quote'
import QuoteDetail from '../components/home.quote/quoteDetail'
import AddQuote from '../components/home.quote/addQuote'
import TradeNews from '../components/home.tradeNews/tradeNews'
import TradeDetail from '../components/home.tradeNews/tradeDetail'

import activitiesDetail2022ts from '../components/home.annualMeeting/activitiesDetail2022ts'
import activitiesDetail2021ts from '../components/home.annualMeeting/activitiesDetail2021ts'
import activitiesDetail2021 from '../components/home.annualMeeting/activitiesDetail2021'
import activitiesDetail2021jy from '../components/home.annualMeeting/activitiesDetail2021jy'
import Activities from '../components/home.annualMeeting/activities'
import ActivitiesDetail from '../components/home.annualMeeting/activitiesDetail'
import activitiesDetail2021zz from '../components/home.annualMeeting/activitiesDetail2021zz'
import activitiesDetail2021ty from '../components/home.annualMeeting/activitiesDetail2021ty'
import activitiesDetail2021gz from '../components/home.annualMeeting/activitiesDetail2021gz'
import activitiesDetail2023bx from '../components/home.annualMeeting/activitiesDetail2023bx'
import activitiesDetail2023jy from '../components/home.annualMeeting/activitiesDetail2023jy'
import activitiesDetail2023qd from '../components/home.annualMeeting/activitiesDetail2023qd'
import activitiesDetail2023hd from '../components/home.annualMeeting/activitiesDetail2023hd'
import activitiesDetail2023hz from '../components/home.annualMeeting/activitiesDetail2023hz'
import activitiesDetail2023zz from '../components/home.annualMeeting/activitiesDetail2023zz'
import activitiesDetail2023tj from '../components/home.annualMeeting/activitiesDetail2023tj'
import DetailVideo from '../components/home.information.detail/detailVideo'
import VideoList from '../components/home.video/videoList'

import Download from '../components/home.download/download'
import HeiTianE from '../components/heitiane/heitiane'
import Activity18TH from '../components/home.activity/activity18th'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter);
const router = new VueRouter({
	routes: [{
			path: '*',
			redirect: '/index/39'
		},
		{
			path: '/index/:id',
			component: Index,
			meta: {
				title: '钢铁产业网',
				content: {
					keywords: '钢铁网,钢铁网站,钢材现货,钢材报价,钢铁行情,钢铁价格,唐山钢材网,钢材价格,唐山钢材,唐山钢铁网',
					description: '中国钢铁产业网是中国钢铁行业信息最准确、最全面的门户网站，包括钢铁,钢材,钢管,钢铁价格,钢材价格,钢铁行情,钢材行情,钢材价格走势,钢铁市场,钢材市场,钢铁期货,钢材现货,钢铁行业,特钢,炉料,钢材贸易等信息，致力于为国内钢铁生产商、经销商、上游、下游等钢铁产业链提供最新、最快、最及时的资讯信息平台和钢铁电子商务服务。'
				}
			}
		},
		{
			path: '/serviceSystem',
			component: ServiceSystem,
			meta: {
				title: '服务体系-钢铁产业网'
			}
		},
		{
			path: '/aboutUs',
			component: AboutUs
		},
		{
			path: '/inforDetailP/:id',
			component: DetailPhone
		},
		{
			path: '/heitiane',
			component: HeiTianE,
			name: '黑天鹅来袭',
			meta: {
				title: '黑天鹅来袭'
			}
		},
		{
			path: '/home',
			component: Home,
			children: [{
					path: 'information/:id',
					component: Information,
					name: '资讯',
					meta: {
						title: '资讯-钢铁产业网'
					}
				},
				{
					path: 'inforDetail/:id',
					component: Detail,
					name: '资讯',
					meta: {
						title: '资讯-钢铁产业网'
					}
				},
				{
					path: 'inforList/:name',
					component: InforList,
					name: '资讯',
					meta: {
						title: '资讯-钢铁产业网'
					}
				},
				{
					path: 'inforFastList',
					component: InforFastList,
					name: '资讯',
					meta: {
						title: '资讯-钢铁产业网'
					}
				},
				{
					path: 'report/:id',
					component: Report,
					name: '研报',
					meta: {
						title: '研报-钢铁产业网'
					}
				},
				{
					path: 'reportDetail/:id',
					component: ReportDetail,
					name: '研报',
					meta: {
						title: '研报-钢铁产业网'
					}
				},
				{
					path: 'priceIndex/:id',
					component: PriceIndex,
					name: '价格指数',
					meta: {
						title: '价格指数-钢铁产业网'
					}
				},
				{
					path: 'basePrice/:id',
					component: BasePrice,
					name: '基准价',
					meta: {
						title: '基准价-钢铁产业网'
					}
				},
				{
					path: 'allPrice',
					component: AllPrice,
					name: '价格',
					meta: {
						title: '价格-钢铁产业网'
					}
				},
				{
					path: 'modifyPrice/:id',
					component: ModifyPrice,
					name: '报价',
					meta: {
						title: '报价-钢铁产业网'
					}
				},
				{
					path: 'customized',
					component: Customized,
					name: '报价',
					meta: {
						title: '报价-钢铁产业网'
					}
				},
				{
					path: 'currentCash/:id',
					component: CurrentCash,
					name: '期现',
					meta: {
						title: '期现-钢铁产业网'
					}
				},
				{
					path: 'billetAdjustment/:id',
					component: BilletAdjustment,
					name: '钢坯调期',
					meta: {
						title: '钢坯调期-钢铁产业网'
					}
				},
				{
					path: 'record/:id',
					component: Record,
					name: '数据',
					meta: {
						title: '数据-钢铁产业网'
					}
				},
				{
					path: 'selfPage',
					component: SelfPage,
					name: '关于我们',
					meta: {
						title: '关于我们-钢铁产业网'
					}
				},
				{
					path: 'changePwd',
					component: ChangePwd,
					name: '修改密码',
					meta: {
						title: '修改密码-钢铁产业网'
					}
				},
				{
					path: 'siteMap',
					component: SiteMap,
					name: '网站地图',
					meta: {
						title: '网站地图-钢铁产业网'
					}
				},
				{
					path: 'feedBack',
					component: FeedBack,
					name: '意见反馈',
					meta: {
						title: '意见反馈-钢铁产业网'
					}
				},
				{
					path: 'searchPage',
					component: SearchPage,
					name: '搜索',
					meta: {
						title: '搜索-钢铁产业网'
					}
				},
				{
					path: 'serviceDetail/:type',
					component: ServiceDetail,
					name: '钢坯调期',
					meta: {
						title: '钢坯调期-钢铁产业网'
					}
				},
				{
					path: 'quote',
					component: Quote,
					name: '企业报价',
					meta: {
						title: '企业报价-钢铁产业网'
					}
				},
				{
					path: 'quoteDetail',
					component: QuoteDetail,
					name: '企业报价',
					meta: {
						title: '企业报价-钢铁产业网'
					}
				},
				{
					path: 'addQuote',
					component: AddQuote,
					name: ''
				},
				{
					path: 'tradeNews',
					component: TradeNews,
					name: '商情',
					meta: {
						title: '商情-钢铁产业网'
					}
				},
				{
					path: 'tradeDetail',
					component: TradeDetail,
					name: '商情',
					meta: {
						title: '商情-钢铁产业网'
					}
				},
				{
					path: 'activities',
					component: Activities,
					name: '峰会频道',
					meta: {
						title: '峰会频道-钢铁产业网'
					}
				},
				{
					path: 'activitiesDetail',
					component: ActivitiesDetail,
					name: '峰会频道',
					meta: {
						title: '峰会频道-钢铁产业网'
					}
				},
				{
					path: 'activitiesDetail2',
					component: activitiesDetail2021,
					name: '峰会频道',
					meta: {
						title: '峰会频道-钢铁产业网'
					}
				},
				{
					path: 'activitiesDetail3',
					component: activitiesDetail2021jy,
					name: '峰会频道',
					meta: {
						title: '峰会频道-钢铁产业网'
					}
				},
				{
					path: 'activitiesDetail4',
					component: activitiesDetail2021zz,
					name: '峰会频道',
					meta: {
						title: '峰会频道-钢铁产业网'
					}
				},
				{
					path: 'activitiesDetail5',
					component: activitiesDetail2021ty,
					name: '峰会频道',
					meta: {
						title: '峰会频道-钢铁产业网'
					}
				},
				{
					path: 'activitiesDetail6',
					component: activitiesDetail2021gz,
					name: '峰会频道',
					meta: {
						title: '峰会频道-钢铁产业网'
					}
				},
				{
					path: 'activitiesDetail7',
					component: activitiesDetail2021ts,
					name: '峰会频道',
					meta: {
						title: '峰会频道-钢铁产业网'
					}
				},
				{
					path: 'activitiesDetail8',
					component: activitiesDetail2022ts,
					name: '峰会频道',
					meta: {
						title: '峰会频道-钢铁产业网'
					}
				},
				{
					path: 'activitiesDetail9',
					component: activitiesDetail2023bx,
					name: '峰会频道',
					meta: {
						title: '峰会频道-钢铁产业网'
					}
				},
				{
					path: 'activitiesDetail10',
					component: activitiesDetail2023jy,
					name: '峰会频道',
					meta: {
						title: '峰会频道-钢铁产业网'
					}
				},
				{
					path: 'activitiesDetail11',
					component: activitiesDetail2023qd,
					name: '峰会频道',
					meta: {
						title: '峰会频道-钢铁产业网'
					}
				},
				{
					path: 'activitiesDetail12',
					component: activitiesDetail2023hd,
					name: '峰会频道',
					meta: {
						title: '峰会频道-钢铁产业网'
					}
				},
				{
					path: 'activitiesDetail13',
					component: activitiesDetail2023hz,
					name: '峰会频道',
					meta: {
						title: '峰会频道-钢铁产业网'
					}
				},
				{
					path: 'activitiesDetail14',
					component: activitiesDetail2023zz,
					name: '峰会频道',
					meta: {
						title: '峰会频道-钢铁产业网'
					}
				},
				{
					path: 'activitiesDetail15',
					component: activitiesDetail2023tj,
					name: '峰会频道',
					meta: {
						title: '峰会频道-钢铁产业网'
					}
				},
				{
					path: 'video',
					component: DetailVideo,
					name: '视频',
					meta: {
						title: '视频-钢铁产业网'
					}
				},
				{
					path: 'videoList',
					component: VideoList,
					name: '视频',
					meta: {
						title: '视频-钢铁产业网'
					}
				},
				{
					path: 'download',
					component: Download,
					name: '下载',
					meta: {
						title: '视频-唐宋数据下载'
					}
				},
				{
					path: '/activity18th',
					component: Activity18TH,
					name: '周年庆促销',
					meta: {
						title: '周年庆促销'
					}
				},
			]
		}
	],

	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return {
				x: 0,
				y: 0
			}
		}
	}
})

export default router
